export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11784.a6c31268.jpg";